import React, { useEffect, useState } from "react";
import Slider from 'react-slick';
import ImageEcoSystem1 from "../../images/Ecosystem-icon-1.png";
import ImageEcoSystem2 from "../../images/Ecosystem-icon-2.png";
import ImageEcoSystem3 from "../../images/Ecosystem-icon-3.png";
import ImageEcoSystem4 from "../../images/Ecosystem-icon-4.png";
import ImageEcoSystem5 from "../../images/Ecosystem-icon-5.png";
import ImageEcoSystem6 from "../../images/Ecosystem-icon-6.png";
import ImageEcoSystem7 from "../../images/Ecosystem-icon-7.png";
import ImageEcoSystem8 from "../../images/Ecosystem-icon-8.png";
import ImageEcoSystem9 from "../../images/Ecosystem-icon-9.png";
import ImageEcoSystem10 from "../../images/Ecosystem-icon-10.png";
import ImageEcoSystem11 from "../../images/Ecosystem-icon-11.png";
import ImageEcoSystem12 from "../../images/Ecosystem-icon-12.png";
import ImageEcoSystem13 from "../../images/Ecosystem-icon-13.png";
import ImageEcoSystem14 from "../../images/Ecosystem-icon-14.png";
import ImageEcoSystem15 from "../../images/Ecosystem-icon-15.png";
import ImageEcoSystem16 from "../../images/Ecosystem-icon-16.png";
import ImageEcoSystem17 from "../../images/Ecosystem-icon-17.png";
import ImageEcoSystem18 from "../../images/Ecosystem-icon-18.png";
import ImageEcoSystem19 from "../../images/Ecosystem-icon-19.png";
import ImageEcoSystem20 from "../../images/Ecosystem-icon-20.png";
import ImageEcoSystem21 from "../../images/Ecosystem-icon-21.png";
import ImageEcoSystem22 from "../../images/Ecosystem-icon-22.png";

import ImageMobile1 from "../../images/mobile-app-img-1.png";
import ImageMobile2 from "../../images/mobile-app-img-2.png";
import ImageMobile3 from "../../images/mobile-app-img-3.png";
import ImageMobile4 from "../../images/mobile-app-img-4.png";
import ImageMobile5 from "../../images/mobile-app-img-5.png";
import ImageIpad1 from "../../images/ipad-img-1.png";
import ImageTestimonail1 from "../../images/testimonial-1.png";
import Parallax from "../common/utils/animations/parallax";
import { directions } from "../common/utils/animations/animationConstants";

export default function CsEcoSystem() {
  const _isMounted = false;
  const [isMobile, setisMobile] = useState(false);

  useEffect(() => {
    const setValues = () => {
      setisMobile(window.innerWidth <= 1023);
    };
    setValues();
    window.addEventListener('resize', () => {
      setValues();
    });
    return () => {
      window.removeEventListener('resize', () => {
        setValues();
      });
    };
  });

  const settings = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 11.2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [

      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 8,
          infinite: true,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 6,
          infinite: true,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 5,
          infinite: true,
          slidesToScroll: 1,
        }
      },
    ]
  };

  const settings1 = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 11.2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    rtl: true,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 8,
          infinite: true,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 6,
          infinite: true,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 5,
          infinite: true,
          slidesToScroll: 1,
        }
      },
    ]
  };

  const settings2 = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
    ]
  };

  const Icons = [
    {
      icon: ImageEcoSystem1,
      name: "ImageEcoSystem1"
    },
    {
      icon: ImageEcoSystem2,
      name: "ImageEcoSystem2"
    },
    {
      icon: ImageEcoSystem3,
      name: "ImageEcoSystem3"
    },
    {
      icon: ImageEcoSystem4,
      name: "ImageEcoSystem4"
    },
    {
      icon: ImageEcoSystem5,
      name: "ImageEcoSystem5"
    },
    {
      icon: ImageEcoSystem6,
      name: "ImageEcoSystem6"
    },
    {
      icon: ImageEcoSystem7,
      name: "ImageEcoSystem7"
    },
    {
      icon: ImageEcoSystem8,
      name: "ImageEcoSystem8"
    },
    {
      icon: ImageEcoSystem9,
      name: "ImageEcoSystem9"
    },
    {
      icon: ImageEcoSystem10,
      name: "ImageEcoSystem10"
    },
    {
      icon: ImageEcoSystem11,
      name: "ImageEcoSystem11"
    },
    {
      icon: ImageEcoSystem12,
      name: "ImageEcoSystem12"
    },
    {
      icon: ImageEcoSystem13,
      name: "ImageEcoSystem13"
    },
    {
      icon: ImageEcoSystem14,
      name: "ImageEcoSystem14"
    },
    {
      icon: ImageEcoSystem15,
      name: "ImageEcoSystem15"
    },
    {
      icon: ImageEcoSystem16,
      name: "ImageEcoSystem16"
    },
    {
      icon: ImageEcoSystem17,
      name: "ImageEcoSystem17"
    },
    {
      icon: ImageEcoSystem18,
      name: "ImageEcoSystem18"
    },
    {
      icon: ImageEcoSystem19,
      name: "ImageEcoSystem19"
    },
    {
      icon: ImageEcoSystem20,
      name: "ImageEcoSystem20"
    },
    {
      icon: ImageEcoSystem21,
      name: "ImageEcoSystem21"
    },
    {
      icon: ImageEcoSystem22,
      name: ""
    },

  ];
  return (
    <div className="cs-ecosystem-section section-gap-large">
      <div className="ecosystem-content">
        <div className="container-small">
          <div className="cs-ecosystem-content">
            <h2 className="h3">The App Store & Ecosystem</h2>
            <p>We wanted to develop each ecosystem of apps that are complementary to Salesmate and are part of the user’s daily workflow. The “app store” strategy is crucial to driving adoption, awareness, and retention. Users can install the apps they like and start using them with Salesmate.</p>

            <p>With APIs, SDK, and Zapier interfaces, we enabled 700+ native and third-party integrations. </p>
          </div>
        </div>
      </div>

      <div className="cs-ecosystem-icon-grid section-gap">
        <div className="container">
          <Parallax classes="ecosystem-top-slider" id="ecosystem-top-slider-anim" direction={directions.TTB} opacity={true} length={70} triggers={[1, 0.7]}>
            <Slider {...settings}>
              {
                Icons.map((item, i) => {
                  if (i < 11)
                    return <div className="ecosystem-icon">
                      <img src={item.icon} alt={item.name} title={item.name} />
                    </div>;
                })
              }
              {/* <div className="ecosystem-icon">
                <img src={ImageEcoSystem11} alt="Ecosystem 1" title="Ecosystem 1" />
              </div> */}
              {isMobile && <>
                <div className="ecosystem-icon">
                  <img src={ImageEcoSystem6} alt="Ecosystem 1" title="Ecosystem 1" />
                </div>
              </>}
            </Slider>
          </Parallax>
          <Parallax classes="ecosystem-bottom-slider" id="ecosystem-bottom-slider-anim" direction={directions.BTT} opacity={true} length={70} triggers={[1, 0.9]}>
            <Slider {...settings1}>
              {isMobile && <>
                <div className="ecosystem-icon">
                  <img src={ImageEcoSystem17} alt="Ecosystem 1" title="Ecosystem 1" />
                </div>
              </>}
              {
                Icons.map((item, i) => {
                  if (i > 10)
                    return <div className="ecosystem-icon">
                      <img src={item.icon} alt={item.name} title={item.name} />
                    </div>;
                })
              }
              {/* <div className="ecosystem-icon">
                <img src={ImageEcoSystem22} alt="Ecosystem 1" title="Ecosystem 1" />
              </div> */}
            </Slider>

          </Parallax>
        </div>
      </div>

      <div className="ecosystem-mobile-apps">
        <div className="container">
          <div className="ecosystem-mobile-apps-content section-gap">
            <h2 className="h3">Mobile Apps</h2>
            <p>When we interviewed potential customers for Salesmate, we found that most of them have to work remotely and on-the-go too. And they need comprehensive access to their customer data and sales tools, not a cookiecutter mobile app with limited functionality. </p>

            <p>Our mobile team brought the entire salesmate experience to Android, iPhone, and iPad with powerful native apps. It made Salesmate the most mobile rich CRM and sales software on the market, and customers loved it and wrote rave reviews about it. </p>
          </div>
        </div>

        <div className="ecosystem-mobile-grid">
          <div className="row d-flex">
            {isMobile && <> <Slider {...settings2}>
              <div className="mobile-img-1"><img src={ImageMobile1} alt="salesmate mobile app" title="salesmate mobile app" /></div>
              <div className="mobile-img-2"><img src={ImageMobile2} alt="mobile crm software" title="mobile crm software" /></div>
              <div className="mobile-img-3"><img src={ImageMobile3} alt="salesmate ios app" title="salesmate ios app" /></div>
              <div className="mobile-img-4"><img src={ImageMobile4} alt="crm mobile app" title="crm mobile app" /></div>
              <div className="mobile-img-5"><img src={ImageMobile5} alt="screenshot 2" title="screenshot 2" /></div>

            </Slider>
              <div className="testimonial-img-1"><img src={ImageTestimonail1} alt="screenshot 1" title="screenshot 1" /></div></>}
            {!isMobile && <>
              <div className="col left-col">
                <div className="mobile-img-2"><img src={ImageMobile2} alt="mobile crm software" title="mobile crm software" /></div>
                <div className="ipad-img-1"><img src={ImageIpad1} alt="salesmate android app" title="salesmate android app" /></div>
                <div className="mobile-img-4"><img src={ImageMobile4} alt="crm mobile app" title="crm mobile app" /></div>
              </div>
              <div className="col right-col">
                <div className="mobile-img-1"><img src={ImageMobile1} alt="salesmate mobile app" title="salesmate mobile app" /></div>
                <div className="mobile-img-3"><img src={ImageMobile3} alt="salesmate ios app" title="salesmate ios app" /></div>
                <div className="testimonial-img-1"><img src={ImageTestimonail1} alt="screenshot 1" title="screenshot 1" /></div>
                <div className="mobile-img-5"><img src={ImageMobile5} alt="screenshot 2" title="screenshot 2" /></div>

              </div>
            </>}
          </div>
        </div>
      </div>
    </div>
  );
}